import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { displaykW } from '../../../helpers/display-energy';
import WidgetLoader from '../../widgets/Loader';

export const CurrentGenerationTypeProvider = (props) => {
  const loading = useSelector((state) => state.timeseries.loading);

  return (
    <DataTypeProvider
      formatterComponent={({ value }) => {
        const generation = get(value, 'generation');
        if (loading) {
          return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <WidgetLoader delay={0} />
            </Box>
          );
        }
        return (
          <Typography align='right'>{`${displaykW(generation)}`}</Typography>
        );
      }}
      {...props}
    />
  );
};
